define('waslider', ['jquery', 'wabreakpoint', 'waajax'], function ($, wabreakpoint, waajax) {

  var waslider = {

    producWrapperClass: 'product__wrapper',
    initJsSliderClassName: 'is__load',
    ownSliderButtons: '.slider__prev, .slider__next',
    ownPrevButton: 'slider__prev',
    ownNextButton: 'slider__next',
    owlNav: 'owl-nav',
    owlDots: 'owl-dots',
    possibleChilds: '.slider__item:not(.last), .js_touchzoom, .product__material--image, .product__material--video',
    opacityClass: 'jsOwnButtonOpacity',
    ajaxSliderClassName: 'js_sliderAjax',

    getSlider: function getSlider(sliderClassName, initOnArray, initOnDeviceArray) {
      var _this = this;

      var sliderAll = $('.' + sliderClassName);
      if (sliderAll.length == 0) return;
      sliderAll.each(function (index, element) {
        var slider = $(element);
        if (slider.children().length >= 1) {
          _this.startCurrentSliderElement(slider, sliderClassName, initOnArray, initOnDeviceArray);
        }
      });
    },
    setButtonStyles: function setButtonStyles(slider) {
      var sliderParent = slider.parent();
      var orgNavDisBtn = slider.find('.owl-nav button.disabled');
      sliderParent.find('.' + this.opacityClass).removeClass(this.opacityClass);

      if (!!orgNavDisBtn) {
        var className = orgNavDisBtn.attr('class');
        if (/prev/i.test(className)) {
          sliderParent.find('.' + this.ownPrevButton).addClass(this.opacityClass);
        }
        if (/next/i.test(className)) {
          sliderParent.find('.' + this.ownNextButton).addClass(this.opacityClass);
        }
      }
    },
    startCurrentSliderElement: function startCurrentSliderElement(slider, sliderClassName, initOnArray, initOnDeviceArray) {
      var _this2 = this;

      var sliderOptions = this.options[sliderClassName] || this.options.default;
      var responsiveOptions = sliderOptions['responsive'] || {};
      var items = slider.data('init');
      var sliderChilds = slider.children(this.possibleChilds).length || 0;

      sliderOptions.items = items || 1;

      if (!$.isEmptyObject(responsiveOptions)) {
        sliderOptions['responsive'] = { 480: { items: items }, 780: { items: items }, 1080: { items: items } };
      }

      if ($.inArray(window.wabreakpoint, initOnArray) !== -1 && $.inArray(this.device, initOnDeviceArray) !== -1) {
        slider.find('.last').remove();
        if (sliderChilds > items) {
          slider.owlCarousel(sliderOptions).parent().addClass(this.initJsSliderClassName);

          slider.on('changed.owl.carousel', function (event) {
            _this2.setButtonStyles(slider);
          });

          this.startSliderNavigation(slider, sliderChilds, sliderOptions.items);
        }
      } else {
        slider.trigger("destroy.owl.carousel").parent().removeClass(this.initJsSliderClassName);
      }

      slider.prev(this.options.loadingClass).hide() && slider.closest('.' + this.producWrapperClass).css('opacity', 1);

      if (typeof this[sliderClassName + 'CallBack'] === 'function') this[sliderClassName + 'CallBack'](slider);
    },
    startSliderNavigation: function startSliderNavigation(slider, sliderChilds, items) {

      if (sliderChilds > items) {
        var sliderParent = slider.parent();
        var dotNavEnabled = !slider.find('.' + this.owlDots).hasClass('disabled') ? true : false;

        if (sliderChilds > 1) {
          sliderParent.find('.' + this.ownPrevButton).addClass(this.opacityClass).end().find(this.ownSliderButtons).show().end().find('.' + this.ownPrevButton).on('click', function (e) {
            var btnPrev = $(e.currentTarget);
            !!dotNavEnabled ? slider.find('.owl-dot.active').prev().trigger('click') : slider.find('.owl-prev').trigger('click');
          }).end().find('.' + this.ownNextButton).on('click', function (e) {
            var btnNext = $(e.currentTarget);
            !!dotNavEnabled ? slider.find('.owl-dot.active').next().trigger('click') : slider.find('.owl-next').trigger('click');
          });
        }
      }
    },

    //callback js_homeSlider
    js_homeSliderCallBack: function js_homeSliderCallBack(slider) {
      slider.on('click', function () {
        slider.closest('.owl-carousel').trigger('stop.owl.autoplay');
      });
    },


    //callback js_productSlider
    js_productSliderCallBack: function js_productSliderCallBack(slider) {
      window.activeOwlSlide = 0;

      var sliderNav = $('.js_productSliderNav');
      var sliderArrowLeft = $('.product__slider .slider__prev');
      var sliderArrowRight = $('.product__slider .slider__next');
      var aniThumb = $('.product__slider--animation');
      var backToProduct = $('.js_motivPreviewBackToProductOnly');

      slider.on('changed.owl.carousel', function () {
        window.activeOwlSlide = slider.find('.owl-item.active > div').data('index');
        if (window.activeOwlSlide === undefined) {
          window.activeOwlSlide = 0;
          var firstSliderItem = slider.parents('.js_productTabs').find('.product__slider--thumbs')[0];
          jQuery(firstSliderItem).addClass('active');
        }
      }).on('dragged.owl.carousel', function () {
        slider.trigger('stop.owl.autoplay');
      });

      sliderArrowLeft.unbind('click').on('click', function () {
        return sliderNav.find('.active').prev().trigger('click');
      });
      sliderArrowRight.unbind('click').on('click', function () {
        return sliderNav.find('.active').next().trigger('click');
      });

      sliderNav.on('click', '[data-thumb]', function (e) {
        sliderNav.find('[data-thumb]').removeClass('active');
        var self = $(e.currentTarget);
        var index = self.data('thumb');
        window.activeOwlSlide = index;
        slider.trigger('to.owl.carousel', [index, 0, true]);
        self.addClass('active');
        if (backToProduct.length > 0 && backToProduct.parent().hasClass('js_showPreview')) {
          backToProduct.trigger('click');
        }
      });

      aniThumb.show().on('click', function (e) {
        var el = $(e.currentTarget);
        var animation = el.data('animation');
        if (!animation) return;
        var index = animation.index;
        el.fadeOut(600);
        var orgBigImg = slider.find('.owl-item [data-index="' + index + '"] img');
        orgBigImg.attr('src', '' + animation.file);
      });
    },

    //callback js_homeSlider
    js_materialSliderCallBack: function js_materialSliderCallBack(slider) {
      var sliderNav = $('.js_materialSliderNav');

      sliderNav.on('click', '[data-thumb]', function (e) {
        var index = $(e.currentTarget).data('thumb');
        slider.trigger('to.owl.carousel', [index, 0, true]);
      });
    },
    sliderReInitOnOrientationChange: function sliderReInitOnOrientationChange() {
      var _this3 = this;

      $(window).on("orientationchange", function () {
        setTimeout(function () {
          _this3.startSlider();
          _this3.startPeeriusSlider();
        }, 250);
      });
    },
    startAjaxSlider: function startAjaxSlider(randomSliderClassName) {
      this.getSlider(randomSliderClassName, ['small', 'medium', 'large'], ["mouse"]);
    },
    startPeeriusSlider: function startPeeriusSlider() {
      this.getSlider('js_sliderPeerius', ['large'], ["mouse"]);
    },
    startSlider: function startSlider() {
      /*Arguments: SliderName, [Breakpoint Activate: small, medium, large] [Device Avivate: 0:touch, 1:mouse]*/
      this.getSlider('js_homeSlider', ['small', 'medium', 'large'], ["touch", "mouse"]);
      this.getSlider('js_categorySlider', ['small', 'medium', 'large'], ["touch", "mouse"]);
      this.getSlider('js_productSlider', ['small', 'medium', 'large'], ["touch", "mouse"]);
      this.getSlider('js_sliderProducts', ['large'], ["mouse"]);
      this.getSlider('js_relatedSmallSlider', ['large'], ["mouse"]);
      this.getSlider('js_materialSlider', ['small', 'medium', 'large'], ["touch", "mouse"]);
      this.getSlider('js_sliderGetAccessories', ['large'], ["mouse"]);
      this.getSlider('js_relatedSlider', ['small', 'medium', 'large'], ["touch", "mouse"]);
      this.getSlider('js_textSlider', ['small', 'medium', 'large'], ["touch", "mouse"]);
      this.getSlider('js_cmsSlider', ['small', 'medium', 'large'], ["touch", "mouse"]);
    },

    //Ajax Slider
    ajaxSlider: function ajaxSlider() {
      var _this4 = this;

      var ajaxSliderElements = $('.' + this.ajaxSliderClassName);
      if (!ajaxSliderElements) return;
      window.inView('.' + this.ajaxSliderClassName).on('enter', function (el) {
        var ajaxSliderElement = $(el);
        if (!ajaxSliderElement.hasClass('js_ajaxWasSent')) {
          var dataUrl = ajaxSliderElement.data('url');
          var dataPartial = ajaxSliderElement.data('partital');
          if (!!dataUrl) ajaxSliderElement.addClass('js_ajaxWasSent');
          _this4.setAjaxCall(ajaxSliderElement, dataUrl, !!dataPartial ? dataPartial : "");
        }
      });
      inView.offset(-500);
    },
    setAjaxCall: function setAjaxCall(sliderElement, url, partial) {
      var _this5 = this;

      waajax.ajax(url, '', partial, function (response) {
        if (!!response) _this5.buildAjaxSlider(sliderElement, response);
      });
    },
    buildAjaxSlider: function buildAjaxSlider(sliderElement, response) {
      var sliderItemsOutput = "";
      var randomSliderClassName = 'js_slider_' + Math.random().toString(36).slice(2);
      sliderElement.addClass(randomSliderClassName);
      sliderItems = response.children('li').slice(0, sliderElement.data('init') * 2);
      sliderItems.each(function (i, el) {
        sliderItemsOutput += '<div class="slider__item">' + $(el).html() + '</div>';
      });
      sliderElement.find('.slider__item.last').before(sliderItemsOutput) && this.startAjaxSlider(randomSliderClassName);
    },
    init: function init() {
      this.device = !!window.isTouchDevice ? "touch" : "mouse";
      this.startSlider();
      this.sliderReInitOnOrientationChange();
      this.ajaxSlider();
    },

    //configuration object for all slider
    options: {
      "loadingClass": ".slider__loading",
      "default": {
        loop: false,
        nav: true,
        dots: true,
        navText: ["", ""],
        lazyLoad: true,
        mouseDrag: false,
        touchDrag: true,
        responsive: {
          480: {
            items: 2
          },
          780: {
            items: 3
          },
          1080: {
            items: 4
          }
        }
      },
      "js_homeSlider": {
        loop: true,
        autoplay: true,
        autoplayTimeout: 10000,
        autoplayHoverPause: true,
        navText: ["", ""],
        lazyLoad: true,
        lazyLoadEager: 1,
        singleItem: true,
        nav: true,
        dots: false,
        mouseDrag: false,
        touchDrag: true
      },
      "js_categorySlider": {
        loop: true,
        autoplay: true,
        autoplayTimeout: 10000,
        autoplayHoverPause: true,
        navText: ["", ""],
        lazyLoad: true,
        lazyLoadEager: 1,
        singleItem: true,
        nav: true,
        dots: false,
        mouseDrag: false,
        touchDrag: true
      },
      "js_productSlider": {
        loop: false,
        navText: ["", ""],
        lazyLoad: true,
        lazyLoadEager: 1,
        singleItem: true,
        nav: true,
        dots: true,
        mouseDrag: false,
        touchDrag: true
      },
      "js_materialSlider": {
        nav: true,
        dots: true,
        navText: ["", ""],
        lazyLoad: true,
        autoplay: false,
        autoplayHoverPause: true,
        singleItem: true,
        mouseDrag: false,
        touchDrag: true,
        responsive: {
          780: {
            dots: false,
            loop: false
          }
        }
      },
      "js_relatedSmallSlider": {
        loop: false,
        margin: 14,
        nav: true,
        dots: true,
        navText: ["", ""],
        lazyLoad: true,
        mouseDrag: false,
        touchDrag: true
      }
    }
  };
  window.waslider = waslider;
  return waslider;
});

